import { Alert, Snackbar } from '@mui/material';
import useSnackbarStore from 'src/store/snackbar';

export const AppSnackbar = () => {
  const { snackbar, closeSnackbar } = useSnackbarStore();

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={snackbar.options.autoHide}
      onClose={closeSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        onClose={closeSnackbar}
        severity={snackbar.options.severity}
        sx={{ width: '100%' }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};
